"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeOnPaymentDataChangeGoogle = void 0;
const formatBraintreeShippingAddressGoogle_1 = require("./formatBraintreeShippingAddressGoogle");
const getBraintreeShippingOptionsGoogle_1 = require("./getBraintreeShippingOptionsGoogle");
const utils_1 = require("../../utils");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const types_1 = require("../../types");
const variables_1 = require("../../variables");
function braintreeOnPaymentDataChangeGoogle(intermediatePaymentData) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const { callbackTrigger, shippingAddress, shippingOptionData } = intermediatePaymentData;
        const paymentDataRequestUpdate = {};
        const intent = callbackTrigger === variables_1.braintreeConstants.GOOGLEPAY_TRIGGER_INITIALIZE ? variables_1.braintreeConstants.GOOGLEPAY_INTENT_SHIPPING_ADDRESS : callbackTrigger;
        switch (callbackTrigger) {
            case variables_1.braintreeConstants.GOOGLEPAY_TRIGGER_INITIALIZE:
            case variables_1.braintreeConstants.GOOGLEPAY_INTENT_SHIPPING_OPTION:
            case variables_1.braintreeConstants.GOOGLEPAY_INTENT_SHIPPING_ADDRESS: {
                if (shippingAddress) {
                    const address = (0, formatBraintreeShippingAddressGoogle_1.formatBraintreeShippingAddressGoogle)(shippingAddress);
                    const shippingAddressResponse = yield (0, utils_1.callShippingAddressEndpoint)(address, true);
                    if (!shippingAddressResponse.success) {
                        paymentDataRequestUpdate.error = {
                            reason: variables_1.braintreeConstants.GOOGLEPAY_ERROR_REASON_SHIPPING,
                            message: (_b = (_a = shippingAddressResponse.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : '',
                            intent
                        };
                        return paymentDataRequestUpdate;
                    }
                }
                const shippingLinesResponse = yield (0, checkout_frontend_library_1.getShippingLines)(types_1.API_RETRY);
                const { selected_shipping: selectedShipping, available_shipping_lines: shippingLines } = (0, checkout_frontend_library_1.getShipping)();
                if (shippingLinesResponse.success) {
                    if (shippingOptionData) {
                        const option = shippingLines.find(line => line.id === shippingOptionData.id);
                        option && (yield (0, checkout_frontend_library_1.changeShippingLine)(option.id, types_1.API_RETRY));
                    }
                    else if (!selectedShipping && shippingLines.length > 0) {
                        yield (0, checkout_frontend_library_1.changeShippingLine)(shippingLines[0].id, types_1.API_RETRY);
                    }
                    yield (0, checkout_frontend_library_1.getShippingLines)(types_1.API_RETRY);
                }
                yield (0, checkout_frontend_library_1.setTaxes)(types_1.API_RETRY);
                const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
                const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
                paymentDataRequestUpdate.newTransactionInfo = {
                    currencyCode: currencyCode,
                    totalPrice: (0, utils_1.getValueByCurrency)(order_total, currencyCode),
                    totalPriceStatus: 'ESTIMATED'
                };
                paymentDataRequestUpdate.newShippingOptionParameters = (0, getBraintreeShippingOptionsGoogle_1.getBraintreeShippingOptionsGoogle)();
                return paymentDataRequestUpdate;
            }
            default: return paymentDataRequestUpdate;
        }
    });
}
exports.braintreeOnPaymentDataChangeGoogle = braintreeOnPaymentDataChangeGoogle;
